var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"blue-btn",on:{"click":function($event){$event.stopPropagation();return _vm.btnClick($event)}}},[_vm._t("default"),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }